/* istanbul ignore file */
import React from 'react';
import useFieldHelper from '../../ui/field/fieldHelper';
import turnUrlIntoLink from './turnUrlIntoLink';

const ReplaceUrlWithLinkChild = ({ child }: { child: React.ReactElement }) => {
  const { getValue } = useFieldHelper(child.props);

  return React.cloneElement(child, {
    value: turnUrlIntoLink(getValue()),
  });
};

export default ReplaceUrlWithLinkChild;
